import React from 'react';
import './index.scss';

export default function Index(props) {
  const { i18n = {}, consumeTip } = props;

  if (consumeTip) {
    return (
      <div className="rick-warning">
        <div className="warning_title">
          <img
            src="//img.alicdn.com/imgextra/i2/O1CN01eWKt1h26NkY6EcDMJ_!!6000000007650-2-tps-28-28.png"
            alt="warning"
            className="warning_icon"
          />
          <span>
            {i18n['details_info.disclaimer_title'] || 'Warning/Disclaimer'}
          </span>
        </div>
        <div className="warning_text">{consumeTip}</div>
      </div>
    );
  }

  return null;
}
